import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

export const exportToCSV = (csvData: any, fileName: string) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });

  FileSaver.saveAs(data, `${fileName}.xlsx`);
};

export const csvToXlsx = (csvString: string, fileName: string) => {
  const workbook = XLSX.read(csvString, { type: 'string', raw: true });

  const ws = convertColumnToNumber('VALOR_NF', workbook);
  const newWorkbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(newWorkbook, ws, 'data');

  const xlsxBuffer = XLSX.write(newWorkbook, {
    bookType: 'xlsx',
    type: 'array',
  });

  const blob = new Blob([xlsxBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  FileSaver.saveAs(blob, fileName);
};

const convertColumnToNumber = (columnName: string, workbook: XLSX.WorkBook) => {
  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];
  const data = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
  const updatedData = data.map((row: any) => {
    if (row[columnName] !== undefined) {
      const num = Number(row[columnName]);
      row[columnName] = isNaN(num) ? row[columnName] : { v: num, t: 'n' };
    }
    return row;
  });

  const newSheet = XLSX.utils.json_to_sheet(updatedData);

  return newSheet;
};
